import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, getUserFacingErrorMessage } from './services/apiClient';
import './components/LoginPage.css';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(
          getUserFacingErrorMessage(res.status, data, data.detail || 'Request failed')
        );
        return;
      }
      setDone(true);
    } catch (err) {
      setError(err.message || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Forgot password</h1>
          <p>We will email you a link to choose a new password.</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        {done ? (
          <div>
            <p style={{ color: 'var(--text-color)', lineHeight: 1.5 }}>
              If an account exists for that email, we sent password reset instructions.
              Check your inbox (and spam folder).
            </p>
            <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              <Link to="/login" className="link-btn">
                Back to sign in
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                required
                placeholder="you@company.com"
                autoComplete="email"
              />
            </div>
            <button type="submit" className="submit-btn" disabled={loading || !email.trim()}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/login" className="link-btn">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
